(function () {
  function allWraps() {
    return Array.prototype.slice.call(document.querySelectorAll('.sh-wrap'));
  }

  function initReveals(root) {
    var els = root.querySelectorAll('.sh-reveal:not(.sh-vis)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('sh-vis');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sh-vis');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function initFaq(root) {
    root.querySelectorAll('.sh-faq-q').forEach(function (btn) {
      if (btn.dataset.shBound) return;
      btn.dataset.shBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.sh-faq-item');
        if (!item) return;
        var panel = item.querySelector('.sh-faq-a');
        var open = item.classList.contains('sh-open');
        var scope = btn.closest('.sh-faq') || root;
        scope.querySelectorAll('.sh-faq-item.sh-open').forEach(function (other) {
          other.classList.remove('sh-open');
          var p = other.querySelector('.sh-faq-a');
          if (p) p.style.maxHeight = null;
          var q = other.querySelector('.sh-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!open && panel) {
          item.classList.add('sh-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#sh-"]').forEach(function (a) {
      if (a.dataset.shBound) return;
      a.dataset.shBound = '1';
      a.addEventListener('click', function (ev) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('.sh-car').forEach(function (car) {
      if (car.dataset.shBound) return;
      car.dataset.shBound = '1';
      var track = car.querySelector('.sh-cards');
      var prev = car.querySelector('.sh-car-prev');
      var next = car.querySelector('.sh-car-next');
      if (!track || !prev || !next) return;
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        var fits = track.scrollWidth <= track.clientWidth + 2;
        prev.style.display = next.style.display = fits ? 'none' : '';
      };
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      setTimeout(sync, 400);
    });
  }

  function boot() {
    allWraps().forEach(function (wrap) {
      initReveals(wrap);
      initFaq(wrap);
      initCarousels(wrap);
    });
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
